<template>
  <section class="container">
    <div class="tutors-curve-price">
      <!--    chart-->
      <div class="tutors-curve-price-chart">
        <TutorListSvgCode class="svg-price-curve" />
        <!--      subtitle-->

        <!--       [min, avg, max] prices-->
        <div class="tutors-curve-price-chart__numbers">
          <span class="chart-price__min">{{ currencySym }}{{ min }} </span>
          <span class="chart-price__avg">{{ currencySym }}{{ avg }}</span>
          <span class="chart-price-max">{{ currencySym }}{{ max }}</span>
        </div>
        <h3 class="tutors-curve-price-chart__subtitle">
          {{ $t('titles.curve_price_hour') }}
        </h3>
        <p class="lg:text__body-3-md--regular text__caption-xs--regular text-body-2 mt-4">
          {{ title }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { currencySymbol } from '@helper/currencySymbol'
import TutorListSvgCode from './curve-svg-code.vue'

export default {
  name: 'StartTeachingCurvePrice',
  components: { TutorListSvgCode },
  data () {
    return {
      min: 10,
      avg: 24,
      max: 38,
      currency: 'USD',
      heading: 'Online teacher jobs average payment',
      title: ''
    }
  },
  computed: {
    ...mapGetters('local', ['getPriceChart']),
    description () {
      return 'Online tutoring gives you this opportunity to raise your hourly rates by finding students from across the world. At Ostado, you can choose your class prices according to your teaching experience, ability, and qualifications. Additionally, we offer you the possibility to raise your rates or just increase the number of students to achieve your salary goals.'
    },
    currencySym () {
      return currencySymbol(this.currency)
    }
  },
  mounted () {
    this.title = this.getPriceChart?.title
    this.min = this.getPriceChart?.values?.min
    this.avg = this.getPriceChart?.values?.avg
    this.max = this.getPriceChart?.values?.max
    this.currency = this.getPriceChart?.currency
  },
  methods: {
    ...mapActions('local', ['fetchListPriceChart'])
  }
}
</script>

<style lang="scss" scoped>
.tutors-curve-price {
  @apply container lg:max-w-[800px] mx-auto rounded-2xl flex flex-col items-center lg:py-10 py-6;
  &__title {
    @apply mb-4 lg:mb-8 ;
  }
}
.svg-price-curve {
  @apply w-[100%] h-auto;
}
.tutors-curve-price-chart {
  @apply text-center text__caption-1-xs--regular lg:text__body-1-md--regular text-label-text;
  &__numbers {
    @apply flex justify-between text__caption-1-xs--regular lg:text__body-2-md--semibold mt-3 mx-11;
    .chart-price__avg {
      @apply text__body-2-xs--bold lg:text__headline-5-md--bold text-body-1;
    }
    .chart-price__min,
    .chart-price-max {
      @apply text-label-text;
    }
  }
  &__subtitle {
    @apply  text__caption-xs--semibold lg:text__body-1-md--semibold mt-1 text-body-1;
  }
}
</style>
